<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">enterprise honor</div>
      <div class="contentTitle">企业荣誉</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="imgBox w">
        <div class="imgItem" v-for="(item, index) in imgObj" :key="index">
          <img :src="item.url" alt />
        </div>
      </div>
    </div>
    <div class="mobile_contentBox">
      <div class="contentStitle">enterprise honor</div>
      <div class="contentTitle">企业荣誉</div>
      <div class="imgBox">
        <div class="imgItem" v-for="(item, index) in imgObj" :key="index">
          <img :src="item.url" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      imgObj: [
        { url: src.honor_1 },
        { url: src.honor_2 },
        { url: src.honor_3 },
        { url: src.honor_4 },
        { url: src.honor_5 },
        { url: src.honor_6 },
        // { url: src.honor_7 },
        { url: src.honor_8 },
        { url: src.honor_9 },
        { url: src.honor_10 },
        // { url: src.honor_11 },
        // { url: src.honor_12 },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 999px) {
  .mobile_contentBox {
    .imgBox {
      width: 330px;
      margin: auto;
    
      .imgItem {
        float: left;
        width: 100px;
        border: 1px solid #cccccc;
        margin-right: 15px;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
        }
      }
      .imgItem:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
@media screen and (min-width: 1000px) {
  .contentBox {
    .imgBox {
      margin: 20px 0;
      height: 1000px;
      .imgItem {
        float: left;
        width: 390px;
        height: 260px;
        border: 1px solid #cccccc;
        margin-right: 15px;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
          height: 260px;
        }
      }
      .imgItem:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
